export default __webpack_public_path__ + "static/monitoring-0bcfc8978b6ff63061e4a2c4cddaa318.png";